export enum SystemNotificationsStyleStateEnum {
    default = 'DEFAULT',
    collapsed = 'COLLAPSED',
    closed = 'CLOSED'
}
